import { generateStore } from 'initial-state';
import { initialState } from './initialState';
import { ISloydStore } from './types';

export const { actions } = generateStore<ISloydStore>(initialState);
